<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-05-16 10:00:32
 * @LastEditors: may.li
 * @LastEditTime: 2023-05-17 11:16:16
-->
<template>
<div :class="show_sku ? 'page_shopdetail page_iteminfo page_limit' : 'page_shopdetail page_iteminfo'" v-if="goodsDetail">
    <div class="goods_logo">
        <van-swipe class="my-swipe detail_swipe" :autoplay="bannerTime">
            <van-swipe-item :show-indicators="false" :loop="false" v-for="(item,index) in goodsDetail.albumArr" :key="index">
                <img :src="item" alt="" />
            </van-swipe-item>
        </van-swipe>
    </div>
    <div class="goods_top">
        <div class="title">
            <span>{{ goodsDetail.title }}</span>
        </div>
        <div class="goods_info">
            <span class="price"><span class="tag_cash">¥</span>{{ goodsDetail.price }}</span>
            <span class="stock">数量<span class="num">{{ goodsDetail.store }}</span></span>
        </div>
		<div class="bijia">
			<a :href="goodsDetail.herf">平台比价>></a>
		</div>
    </div>
    <div class="xiangqing">
        <p v-html="goodsDetail.content" class="jieshao"></p>
    </div>
    <div class="bottom">
        <div class="action buynow big_btn" @click="onShowSku(1)">立即购买</div>
    </div>
    <!-- 规格弹窗 -->
    <div class="sku_wrap" v-if="show_sku">
        <div class="sku">
            <div class="sku_t">
                <div class="sku_t_l" @click="showGoodsImage">
                    <img :src="goodsDetail.thumb" alt="" class="tu" />
                </div>
                <div class="sku_t_r">
                    <div class="price">
                        <span class="tag_cash">¥{{ goodsDetail.price }}</span>
                    </div>
                    <div class="sku_title">库存：{{ goodsDetail.store }}件</div>
                    <div class="sku_title slh">{{ goodsDetail.title }}</div>
                </div>
            </div>
            <div class="sku_nums clearfix">
                <div class="sku_nums_l f-l">数量</div>
                <div class="adjustSku f-r">
                    <van-stepper v-model="selectNum" />
                </div>
            </div>
        </div>
        <!-- 按钮区 -->
        <div class="sku_actions">
            <div class="sku_action" @click="onAddCartClicked">立即购买</div>
        </div>
    </div>
    <van-image-preview v-model="showSkuImage" :images="skuImages" :closeable="true">
    </van-image-preview>
    <!-- 全局的弹层 遮罩-->
    <van-overlay :show="show_sku" @click="show_sku=false;bannerTime='3000'" class="sku_overlay" />
</div>
</template>

<script>
export default {
    data() {
        return {
			token: null,
			companyId: null,
			goodsId: null,
            bannerTime: '3000',
            goodsDetail: null,
			show_sku: false,
			selectNum: 1,
			showSkuImage: false,
			skuImages: [],
            imageUrl: this.$publicData.uploadImage,
        }
    },
    created() {
		this.token = this.$store.getters.token;
		this.companyId = this.$route.query.companyId;
		this.goodsId = this.$route.query.goodsId;
        this.getGoodsDetailData()
    },
    methods: {
        /**
         * @name: 详情
         * @return {*}
         * @desc: 
         */		
        getGoodsDetailData() {
            let that = this;
            let params = {
                token: this.token,
				company_id: this.companyId,
                good_id: this.goodsId
            };
            this.$api.thirdshop.gooddetail(params).then(res => {
                if (res.code == 200) {
					let goodsDetail = res.result;
					// 顶部轮播图
					let arr = null;
					if(goodsDetail.album){
						arr = goodsDetail.album.split(',').filter(item => item != '');
					}else{
						arr = [];
					};
					goodsDetail.albumArr = arr;
                    this.goodsDetail = goodsDetail;
                }else{
					this.$toast(res.message)
				}
            })
        },
        /**
         * @name: 规格
         * @return {*}
         * @desc: 
         */		
        onShowSku() {
			this.show_sku = true;
            this.bannerTime = '-'
        },
		/**
		 * @name: 大图
		 * @return {*}
		 * @desc: 
		 */		
		showGoodsImage(){
			this.showSkuImage = true
			this.skuImages = [this.goodsDetail.thumb]
		},
		/**
		 * @name: 购买
		 * @return {*}
		 * @desc: 
		 */		
		onAddCartClicked(){
			let that = this;
			if(this.token){
				// 将结算页需要的信息，存下来，不出接口
				let data = {
					company_id: this.goodsDetail.company_id,
					goods_id: this.goodsDetail.good_id,
					num: this.selectNum,
					goods_thumb: this.goodsDetail.thumb,
					goods_title: this.goodsDetail.title,
					goods_price: this.goodsDetail.price
				};
				that.$store.commit('SETTLE', {
					shop_settle: JSON.stringify(data),
				});
				this.$router.push({
					path: "/third/settle"
				});
			}else{
				localStorage.setItem('redirect', that.$router.currentRoute.fullPath)
				that.$router.push({
					path: '/login',
				})
			}
		}
    },
}
</script>
<style scoped>
	.action.buynow{
		width: 8.93rem;
		height: 0.93rem;
		margin: 0 auto;
		border-radius: 0.47rem;
		font-size: 0.4rem;
		color: rgba(255, 255, 255, 1);
		text-align: center;
		line-height: 0.93rem;
		background: linear-gradient( 90deg, rgba(223, 52, 52, 1), rgba(255, 95, 52, 1));
	}
	.goods_top .bijia{
		text-align: right;
		color: rgba(211, 68, 68, 1);
	}
	.goods_top .bijia a{
		color: rgba(211, 68, 68, 1);
	}
</style>